import { useEffect, useState, useRef } from "react";
import { api, formatApiError, BACKEND_URL } from "@/lib/api";
import { toast } from "sonner";
import { Upload, Trash2 } from "lucide-react";

export function AdminMedia() {
  const [items, setItems] = useState([]);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef();

  const load = () => api.get("/admin/media").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const upload = async (files) => {
    if (!files || files.length === 0) return;
    setUploading(true);
    for (const f of files) {
      try {
        const fd = new FormData();
        fd.append("file", f);
        await api.post("/admin/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      } catch (e) { toast.error(formatApiError(e)); }
    }
    setUploading(false); toast.success("Uploaded"); load();
  };

  const del = async (id) => { await api.delete(`/admin/media/${id}`); load(); };

  return (
    <div data-testid="page-admin-media" className="max-w-6xl">
      <div className="flex items-center justify-between mb-8">
        <div><div className="text-[10px] uppercase tracking-[0.28em] text-[#7A736C] mb-2">Library</div><h1 className="font-serif text-4xl tracking-tight">Media</h1></div>
        <label className="cursor-pointer inline-flex items-center gap-2 px-5 py-2.5 bg-[#A85C42] text-white text-xs uppercase tracking-[0.2em] rounded-sm hover:bg-[#2B2927]">
          <Upload size={14} /> {uploading ? "Uploading…" : "Upload"}
          <input ref={fileRef} type="file" multiple hidden accept="image/*,application/pdf" data-testid="media-upload-input" onChange={(e) => upload(e.target.files)} />
        </label>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {items.map((m) => (
          <div key={m.id} data-testid={`media-${m.id}`} className="bg-white border border-[#D5D0C8] rounded-sm overflow-hidden group relative">
            {m.content_type?.startsWith("image/") ? (
              <img src={`${BACKEND_URL}${m.url}`} alt={m.alt || m.original_filename} className="w-full aspect-square object-cover" />
            ) : (
              <div className="w-full aspect-square flex items-center justify-center bg-[#EAE6DF] text-xs text-[#7A736C]">{m.content_type || "file"}</div>
            )}
            <div className="p-3 text-xs">
              <div className="truncate">{m.original_filename}</div>
              <div className="text-[#7A736C] mt-1">{Math.round((m.size || 0) / 1024)} KB</div>
              <div className="flex items-center justify-between mt-2">
                <button onClick={() => { navigator.clipboard.writeText(`${BACKEND_URL}${m.url}`); toast.success("URL copied"); }} className="underline hover:text-[#A85C42]">Copy URL</button>
                <button onClick={() => del(m.id)} className="text-[#7A736C] hover:text-red-600"><Trash2 size={14} /></button>
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="col-span-full text-center py-16 text-[#7A736C]">No media yet.</div>}
      </div>
    </div>
  );
}
